/*
 * @Author: Chao Yang
 * @Date: 2020-03-09 11:09:37
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-03-15 02:02:57
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as Account from 'src/app/domain/model/account';
import { BaseProxy } from '../base.proxy';
import * as IDtoAccountGroup from 'src/app/domain/model/account-group/index';

@Injectable()
export class TaskProxy extends BaseProxy {
  createUserResponse(
    response: Account.IUpdateDocumentResponse
  ): Observable<number[]> {
    return this._http.post<number[]>('/ip/api/feed/task', response);
  }

  getProgramTask(
    programId: number,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Account.ITask[]> {
    return this._http.post<Account.ITask[]>(
      '/ip/api/feed/program/' + programId + '/account/detail/task',
      accounts
    );
  }

  getTasks(accounts: IDtoAccountGroup.IAccountItem[]) {
    return this._http.post<Account.ITask[]>(
      '/ip/api/feed/dashboard/task',
      accounts
    );
  }
}
